import { returnHistory } from './return-history-de.i18n';

export const de = {
  returnHistory,
};
